import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InsuranceRegularDriverDataComponent } from './insurance-regular-driver-data.component';
import { WucDisplayFieldModule, WucLinkModule } from '@inshared/website-ui-components';

@NgModule({
    imports: [
        CommonModule,
        WucDisplayFieldModule,
        WucLinkModule,
    ],
    exports: [
        InsuranceRegularDriverDataComponent,
    ],
    declarations: [
        InsuranceRegularDriverDataComponent,
    ],
})
export class InsuranceRegularDriverDataModule {}
